import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useHandleResize } from '../../utils/handleResize';

/**
 * useLayoutCollapse hook.
 * @hook
 * @returns {Object} - The useLayoutCollapse hook.
 */
export const useLayoutCollapse = () => {
  const location = useLocation();
  const { width, height } = useHandleResize();
  const [collapsed, setCollapsed] = useState(globalThis.innerWidth < 992);
  const [collapseWidth, setCollapseWidth] = useState(
    globalThis.innerWidth < 576 ? 0 : 80
  );

  const onCollapse = (newCollapsed) => {
    setCollapsed(newCollapsed);
  };

  const siderWidth = collapsed ? collapseWidth : 256;

  useEffect(() => {
    if (width < 576) {
      setCollapseWidth(0);
    } else {
      setCollapseWidth(80);
    }
  }, [width, height]);

  useEffect(() => {
    document
      .getElementById('mainContent')
      .scrollTo({ behavior: 'smooth', top: 0 });
  }, [location]);

  return { collapsed, setCollapsed, collapseWidth, siderWidth, onCollapse };
};
